import { getTrades } from "@/Groups/Polymarket/private/api/getTrades";
import { isLoading } from "@/Groups/Signals/store/modules/getters";

const Polymarket = {
  namespaced: true,

  state: {
    data: [],
    map: [],
    next: null,
    isReady: false,
    isLoadingNext: false,
  },

  actions: {
    async init({ state, commit }){
      const data = await getTrades();
      console.log(data)
      commit('SET_DATA', data.results);
      commit('SET_NEXT', data.next);
      commit('SET_READY_FLAG', true);
      console.log(state.data);
      console.log(state.map);
    },

    async loadNext({ state, commit }){
      commit('SET_IS_LOADING_NEXT', true);
      const data = await getTrades({ url: state.next });
      console.log(data)
      commit('SET_DATA', data.results);
      commit('SET_NEXT', data.next);
      commit('SET_IS_LOADING_NEXT', false);
    }
  },

  mutations: {
    SET_DATA(state, data){
      data.forEach((trade) => {
        if (!state.map.includes(trade.id)) {
          state.data[trade.id] = trade;
          state.map.push(trade.id);
        }
      });
    },

    SET_READY_FLAG(state, status){
      state.isReady = status;
    },

    SET_NEXT(state, nextUrl){
      state.next = nextUrl;
    }
  },

  getters: {
   //Получить все торговые операции в виде массива
    allTrades: (state) => { return state.data; },

    //Получить торговую операцию по ID
    tradeById: (state) => (id) => { return state.data[id] || null; },

    //Получить количество торговых операций
    tradesMap: (state) => { return state.map; },

    //Проверить, загружены ли данные
    isReady: (state) => { return state.isReady; },

    //Подгружается ли следующая страница с данными
    isLoadingNext: (state) => { return state.isLoadingNext },

    //Url следующей страницы
    nextUrl: (state) => { return state.next },
  }
}

export default Polymarket;